import { render, staticRenderFns } from "./AuthorizedLayout.vue?vue&type=template&id=17cfe525"
import script from "./AuthorizedLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizedLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedLayout.vue?vue&type=style&index=0&id=17cfe525&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports